export const HeaderContent = {
  logo: "./images/yc-logo.jpeg",
  buttonText: "Order Now",
};
